var ClientType = 'Admin';
var AppVersion = '2.3.13';

module.exports = {
	ClientType: ClientType,
	AppVersion: AppVersion
}